import { render, staticRenderFns } from "./ProdBlacklist.vue?vue&type=template&id=9c339316"
import script from "./ProdBlacklist.vue?vue&type=script&lang=js"
export * from "./ProdBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports